import { v4 as uuidv4 } from 'uuid'

import { Blot, QuillStatic } from "../../types";

import { 
  GESTURE_BLOT_NAME, 
  GESTURE_CLASS_NAME, 
  GESTURE_TAG_NAME,
} from "./constants";
import { GestureValueForGet, GestureValueForSet } from "./types";

const QUILL_STORE: {
  Quill?: QuillStatic
} = {}

export const registerGestureBlot = (Quill: QuillStatic) => {
  QUILL_STORE.Quill = Quill

  const Embed = Quill.import('blots/embed')

  class Gesture extends Embed {
    static blotName = GESTURE_BLOT_NAME;

    static tagName = GESTURE_TAG_NAME;

    static className = GESTURE_CLASS_NAME

    static create({
      gestureId,
      localeLabel,
    }: GestureValueForSet) {
      const node = super.create();

      /**
       * 아이디의 사용처는 UI 기능 상에서 선택된 엘리멘트를 찾는데에만 사용됨\
       * 영구적으로 저장될 필요가 없고\
       * 다른 엘리멘트와 중복되지 않고\
       * 매번 새로운 아이디가 할당되어도 문제 없음
       */
      node.id = uuidv4()
      node.setAttribute('gid', gestureId)
      node.classList.add('gestureButton')
      node.innerText = localeLabel

      /**
       * blot 바로 뒤에 커서가 붙어있을 때, 한글을 입력하면 자모가 분리되는 현상 해결
       */
      node.setAttribute('contenteditable', 'false')

      return node;
    }

    static value(domNode: HTMLElement): GestureValueForGet {
      const childEl = domNode.querySelector(GESTURE_TAG_NAME)

      /**
       * 현재는 gesture 태그가 루트에 존재하지만\
       * 기존에 저장된 포맷으로는 gesture가 자식으로 존재할 수 있음\
       * 기존 데이터와의 호환성을 위해 자식 중에 gesture가 존재하는지 확인하는 로직을 넣음
       */
      if (!!childEl) {
        const id = childEl.getAttribute('id')!;
        const gestureId = childEl.getAttribute('gid')!;
        const localeLabel = (childEl.textContent || '').trim();

        return {
          id,
          gestureId,
          localeLabel,
        }
      }

      const gestureId = domNode.getAttribute('gid')!;
      const id = domNode.getAttribute('id')!;
      const localeLabel = (domNode.textContent || '').trim();

      return {
        gestureId,
        id,
        localeLabel,
      }
    }
  }

  Quill.register(Gesture, true)

  return Gesture
}

export const findClosestGestureEl = (el: HTMLElement) => {
  return el.closest<HTMLElement>(GESTURE_TAG_NAME)
}

export const findGestureBlot = (
  el: HTMLElement,
): Blot<
  typeof GESTURE_BLOT_NAME, 
  GestureValueForGet, 
  GestureValueForSet
> | undefined => {
  const Quill = QUILL_STORE.Quill
  if (!Quill) {
    return
  }

  const closestEl = findClosestGestureEl(el)

  if (!closestEl) {
    return
  }

  return Quill.find(closestEl)
}

export const findGestureBlotById = (id?: string) => {
  if (!id) {
    return
  }

  const el = document.getElementById(id)

  if (!el) {
    return
  }

  return findGestureBlot(el)
}
